import { CollapseProps } from "antd";

export enum AccordionVariant {
  FILLED = "filled",
  TRANSPARENT = "transparent",
}

export interface BaseAccordionProps extends CollapseProps {
  className?: string;
  variant?: AccordionVariant;
}
